/**
 * Type of one single product property
 */
export enum PropertyType {
  IfcPropertySingleValue = 0,
  IfcPropertyListValue = 1,
  IfcPropertyBoundedValue = 2
}
